<script>

  export let url;
  export let title;
  export let description;
  export let imageUrl;
  export let siteName;


  let width = 0;

  $: showHorizontally = width > 600;

</script>

<a href={url} class="clickable" target="_blank" on:click={e => e.stopPropagation()}>
  <div class="og" class:row={showHorizontally} bind:clientWidth={width}>
    <div class="og-image"
         style="{imageUrl ? `background-image: url('${imageUrl}');` : ''}; width: {showHorizontally ? '160px' : '100%'}; height: {showHorizontally ? 90 : (width / 16 * 9)}px;"/>
    <column expand>
      <div class="title" class:untitled={!title}>{title || 'Untitled'}{siteName ? ' - ' + siteName : ''}</div>
      <div class="description">{description || ''}</div>
    </column>
  </div>
</a>

<style>
  a {
    display: block;
    margin: 4px 0;
  }

  .og {
    box-shadow: 0 0 1px 1px #eee;
    line-height: 1.5em;
  }

  .og-image {
    background-size: cover;
    background-position: center;
    background-color: #eee;
  }

  column {
    margin: 4px 8px;
  }

  .title {
    font-size: 1.1rem;
  }

  .untitled {
    color: #888;
  }

  .description {
    font-size: .9rem;
    color: #888;
  }

</style>